import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["customLocales", "isAnonymous", "disableAuthDialog", "bannerProps"];
import { Fragment, useState } from "react";
import { getSourceEventParams } from "@crehana/analytics";
import { useTranslation } from "@crehana/i18n";
import Banner from "../Banner";
import { useUITheme } from "../Layouts/UITheme";
import LightMenu from "../LightMenu";
import { useAuthDialog } from "../ReactContexts/AuthDialog";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LightMenuWithTopBannerAndAuthDialog = function LightMenuWithTopBannerAndAuthDialog(_ref) {
  var _mainMenuProps$layout;
  var customLocalesProp = _ref.customLocales,
    isAnonymous = _ref.isAnonymous,
    disableAuthDialog = _ref.disableAuthDialog,
    bannerProps = _ref.bannerProps,
    mainMenuProps = _objectWithoutProperties(_ref, _excluded);
  var _useUITheme = useUITheme(),
    theme = _useUITheme.theme,
    toggleTheme = _useUITheme.toggleTheme;
  var _useAuthDialog = useAuthDialog(),
    showLoginModal = _useAuthDialog.showLoginModal,
    showRegisterModal = _useAuthDialog.showRegisterModal,
    preloadAuthDialog = _useAuthDialog.preloadAuthDialog;
  var _useTranslation = useTranslation(),
    countryCode = _useTranslation.countryCode;
  var onLogin = function onLogin() {
    showLoginModal(window.location.pathname + window.location.search);
  };
  var onRegister = function onRegister() {
    showRegisterModal(window.location.pathname + window.location.search, undefined, _objectSpread({
      isRenderedIn: mainMenuProps.amplitudePageName
    }, getSourceEventParams()), 'Main Menu');
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    topBannerIsOpen = _useState2[0],
    setTopBannerIsOpen = _useState2[1];
  var onToggleTopBanner = function onToggleTopBanner(isOpen) {
    setTopBannerIsOpen(isOpen);
  };
  var authProps = !disableAuthDialog ? {
    onLogin: onLogin,
    onRegister: onRegister,
    onAuthButtonHover: preloadAuthDialog
  } : {};
  var canRenderTopBanner = !((_mainMenuProps$layout = mainMenuProps.layoutConfig) !== null && _mainMenuProps$layout !== void 0 && _mainMenuProps$layout.hideTopBanner);
  var MainMenuComponent = /*#__PURE__*/_jsx(LightMenu, _objectSpread(_objectSpread({}, mainMenuProps), {}, {
    userTheme: theme,
    onToggleUserTheme: toggleTheme,
    countryPrefix: countryCode || '',
    customLocales: customLocalesProp,
    topBannerIsOpen: topBannerIsOpen
  }, authProps));
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [canRenderTopBanner && /*#__PURE__*/_jsx(Banner, _objectSpread(_objectSpread({}, bannerProps), {}, {
      amplitudePageName: mainMenuProps.amplitudePageName,
      onToggleTopBanner: onToggleTopBanner
    })), canRenderTopBanner && mainMenuProps.position === 'absolute' ? /*#__PURE__*/_jsx("header", {
      className: "relative",
      children: MainMenuComponent
    }) : MainMenuComponent]
  });
};
export default LightMenuWithTopBannerAndAuthDialog;